import { withStyles } from '@material-ui/core/styles';
import Badge from '@material-ui/core/Badge';

export default withStyles(theme => ({
    badge: {
        right: -20,
        top: '50%',
    },
}))(Badge);
